import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=3ca9a452&"
import script from "./skeleton.vue?vue&type=script&lang=ts&"
export * from "./skeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports